import { Button } from 'callahan-react'
import React from 'react'
import { Link } from 'react-router-dom'

import { ADMIN_BASE_URL } from '../constants/route-constants'

const BackButton = ({ onClick }) => (
  <Link to={ADMIN_BASE_URL}>
    <Button
      className="back-button"
      buttonType="secondary"
      icon={['fas', 'chevron-left']}
      onClick={onClick}
    />
  </Link>
)

BackButton.defaultProps = {
  onClick: null
}

export default BackButton



// WEBPACK FOOTER //
// ./src/components/BackButton.js